export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00620.f02eb8f7.png";